export const inventory = {
  state: {
    stockAlertWasShowed: false,
    isLoading: false,
    mode: 'formatting',
    confirmedOperations: [],
    items: [],
  },
  mutations: {
    setStockAlertStatus(state, value) {
      state.stockAlertWasShowed = value;
    },
    setLoadStatus(state, value) {
      state.isLoading = value;
    },
    setMode(state, value) {
      const possibleValues = ['ready-to-send', 'formatting'];
      if (possibleValues.includes(value)) {
        state.mode = value;
      }
    },
    addConfirmedOperation(state, value) {
      const allowedValues = ['arrivals', 'write_offs'];
      if (allowedValues.includes(value)) {
        state.confirmedOperations.push(value);
      }
    },
    dropConfirmedOperations(state) {
      state.confirmedOperations = [];
    },
    addItem(state, item) {
      state.items.push(item);
    },
    updateItems(state, items) {
      state.items = items;
    },
  },
  actions: {
    reset(context) {
      context.commit('setLoadStatus', false);
      context.commit('setMode', 'formatting');
      context.commit('updateItems', []);
      context.commit('setStockAlertStatus', false);
      context.commit('dropConfirmedOperations');
    },
  },
};



// WEBPACK FOOTER //
// ./src/stock/store/inventory.js